import styled from 'styled-components';

export const DeleteClientSubtitle = styled.p`
  ${(props) => props.theme.typography.description};
  margin-bottom: 8px;
`;

export const SuccessModalWrapper = styled.div`
  padding-top: 32px;
  margin-bottom: 32px;
  text-align: center;
`;
